// extracted by mini-css-extract-plugin
module.exports = {"application":"style-module--application--1aRq4","loading":"style-module--loading--v4txv","languageSelectorButton":"style-module--languageSelectorButton--sump7"};